import dp3 from "../../assets/disposable-products/dp-3.png";
import dp4 from "../../assets/disposable-products/dp-4.png";
import dp5 from "../../assets/disposable-products/dp-5.png";
import dp6 from "../../assets/disposable-products/dp-6.png";
import dp7 from "../../assets/disposable-products/dp-7.png";
import dp8 from "../../assets/disposable-products/dp-8.png";
import dp9 from "../../assets/disposable-products/dp-9.png";
import dp10 from "../../assets/disposable-products/dp-10.png";
import dp11 from "../../assets/disposable-products/dp-11.png";
import dp12 from "../../assets/disposable-products/dp-12.png";
import dp13 from "../../assets/disposable-products/dp-13.png";
import dp14 from "../../assets/disposable-products/dp-14.png";
import dp15 from "../../assets/disposable-products/dp-15.png";
import dp16 from "../../assets/disposable-products/dp-16.png";
import dp17 from "../../assets/disposable-products/dp-17.png";
import dp18 from "../../assets/disposable-products/dp-18.png";
import dp19 from "../../assets/disposable-products/dp-19.png";
import dp20 from "../../assets/disposable-products/dp-20.png";
import dp21 from "../../assets/disposable-products/dp-21.png";
import dp22 from "../../assets/disposable-products/dp-22.png";

const dataDisposableGloves = [
  {
    image: dp3,
    productHeader: "Non woven face mask",
    points: [
      "Material - Non woven 25 GSM",
      "Color - Blue",
      "No. of Layer - 3 Ply",
    ],
  },
  {
    image: dp4,
    productHeader: "3 Ply Non Woven Melt Blown Face Mask",
    points: [
      "Material - Non woven 25 GSM",
      "Color - Blue",
      "No. of Layer - 3 Ply",
      "Melt Blown Bacteria Filter"
    ],
  },
   {
    image: dp5,
    productHeader: "Disposable 3 ply Surgical Tie Mask Meltblown",
    points: [
      "Material-Melt Blown 25 GSM",
      "Color-Blue/Green",
      "No. of Layer - 3 Ply",
      "Melt Blown Bacteria Filter"
    ],
  },
   {
    image: dp6,
    productHeader: "3 Ply Melt Blown Face Mask",
    points: [
      "Material - Non woven 25 GSM",
      "Color - Blue (Box Packing)",
      "No. of Layer - 3 Ply",
      "Melt Blown Bacteria Filter",
      "Weight - 187 Gram"
    ],
  },
    {
    image: dp7,
    productHeader: "Non woven Black Face mask",
    points: [
      "Material - Non woven 25 GSM",
      "Color - Black",
      "No. of Layer - 3 Ply"
    ],
  },
  {
    image: dp8,
    productHeader: "Green Cotton Mask",
    points: [
      "Material - cotton",
      "Color - Green",
    ],
  },
   {
    image: dp9,
    productHeader: "Disposable Surgeon Cap",
    points: [
      "Material - Non woven",
      "Color - Blue",
      "Usage / Application - Surgical",
      "Features - Disposable",
      "GSM - 25 GSM"
    ],
  },
     {
    image: dp10,
    productHeader: "White Non woven Bouffant Cap",
    points: [
      "Material - Non woven",
      "Color - White/Green/Blue",
      "Usage / Application - Surgical",
      "Size - 18 inch",
      "GSM - 8.5 GSM"
    ],
  },
     {
    image: dp11,
    productHeader: "White Non woven Bouffant Cap",
    points: [
      "Material - Non woven",
      "Color -Blue White/Green",
      "Usage / Application - Surgical",
      "Size - 21 inch",
      "GSM - 8.5 GSM"
    ],
  },
     {
    image: dp12,
    productHeader: "White Non woven Bouffant Cap",
    points: [
      "Material - Non woven",
      "Color -Green/Blue /White",
      "Usage / Application - Surgical",
       "Size - 24 inch",
      "GSM - 8.5 GSM"
    ],
  },
     {
    image: dp13,
    productHeader: "Non woven Disposable Medical Cap",
    points: [
      "Material - Non woven",
      "Color - Green, Blue, White",
      "Usage/Application - Hospitals",
       "Size - 18 inch/21 inch/24 inch",
      "GSM - 8.5 GSM"
    ],
  },
   {
    image: dp14,
    productHeader: "Lab Disposable Shoe Cover",
    points: [
      "Material - LDPE Plastic",
      "Color - Blue",
      "Usage/Application - Hospitals",
       "Usage / Application - Lab",
      "GSM - 80 Gauge"
    ],
  },
   {
    image: dp15,
    productHeader: "Non woven Disposable Shoe Cover",
    points: [
      "Material - Non woven",
      "Color - Blue",
      "Usage/Application - Hospitals",
       "Usage / Application - Safety purpose",
      "GSM - 25 GSM"
    ],
  },
  {
    image: dp16,
    productHeader: "Disposable Lab Coat",
    points: [
      "Fabric - Non Woven 40 GSM/30 GSM",
      "Color - white",
      "Sleeves type - Full Sleeve",
       "Pattern - Plain",
      "Size -42"
    ],
  },
   {
    image: dp17,
    productHeader: "Disposable Lab coat with Pant",
    points: [
      "Fabric - Non Woven 40 GSM",
      "Color - white",
      "Sleeves type - Full Sleeve",
       "Pattern - Plain",
      "Size -42"
    ],
  },
  {
    image: dp18,
    productHeader: "Disposable Bed Sheet",
    points: [
      "Fabric - Non Woven",
      "Color - white",
      "Usage - Hospital, Spa Clinic",
       "Size - 31.50x70 cm",
      "GSM - 20 GSM"
    ],
  },
    {
    image: dp19,
    productHeader: "White Lint free Duster Cloth",
    points: [
      "Material - lycra",
      "Color - white",
      "Usage/Application - Machine cleaning",
       `Size - 12"x13"`,
      "GSM - 150 Gsm"
    ],
  },
    {
    image: dp20,
    productHeader: "Blue Lint Free Duster Cloth",
    points: [
      "Material - lycra",
      "Color - Blue",
      "Usage/Application-Laboratory instrument cleaning",
       `Size - 10"x12"`,
      "GSM - 100 GSM"
    ],
  },
    {
    image: dp21,
    productHeader: "White Lint free Duster Cloth",
    points: [
      "Material - Polyster",
      "Color - White",
      "Usage/Application - Machine cleaning",
       `Size - 12"x12"`,
      "GSM - 150 Gsm"
    ],
  },
    {
    image: dp22,
    productHeader: "White Lint free Duster Cloth",
    points: [
      "Material - Non woven",
      "Color - white",
      "Usage/Application - Machine cleaning",
       `Size - 9"X9"`,
      "GSM - 100 Gsm"
    ],
  },
];

export const DisposableProductsConstant = {
  dataDisposableGloves: dataDisposableGloves,
};
